import type { Language } from '@musedrops/shared';
import { fromDbKeys } from '@musedrops/shared';
import { supabase } from '../services/supabase';

/** List all available languages sorted by name */
export async function listLanguages(): Promise<{
  data: Language[];
  total?: number;
}> {
  const { data, error, count } = await supabase
    .from('languages')
    .select('*', { count: 'exact' })
    .order('name', { ascending: true });

  if (error) {
    throw new Error(`Failed to fetch languages: ${error.message}`);
  }

  return {
    data: fromDbKeys<Language[]>(data || []),
    total: count || undefined,
  };
}

/** Get a single language by key */
export async function getLanguage(key: string): Promise<Language> {
  const { data, error } = await supabase
    .from('languages')
    .select('*')
    .eq('key', key)
    .single();

  if (error || !data) {
    throw new Error(`Language not found: ${key}`);
  }

  return fromDbKeys<Language>(data);
}

/** Get all languages (alias for listLanguages for consistency) */
export async function getAllLanguages(): Promise<Language[]> {
  const { data } = await listLanguages();
  return data;
}
